export const EMBED_MODAL_TABS = {
  Overview: "overview" as const,
  Parameters: "parameters" as const,
  Appearance: "appearance" as const,
};
